// cookie管理类
export class CookieManage{
    public  static clearCookie(name:string){
        document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }
}

export enum CookieNameEnum{
    ACCESS_TOKEN = "access_token",
    PASSPORT_HOST = "passport_host",
}